import React, { createContext, useState, useMemo, useContext } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const ThemeContext = createContext({
    toggleColorMode: () => { },
    mode: 'light',
});

export const useColorMode = () => useContext(ThemeContext);

export const ThemeContextProvider = ({ children }) => {
    const [mode, setMode] = useState('light');

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
            },
            mode,
        }),
        [mode],
    );

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    primary: {
                        main: mode === 'light' ? '#7c4dff' : '#bb86fc',
                        light: '#b47cff',
                        dark: '#3f1dcb',
                    },
                    secondary: {
                        main: '#ff4081',
                    },
                    background: {
                        default: mode === 'light' ? '#ffffff' : '#050505',
                        paper: mode === 'light' ? '#f5f5f5' : '#121212',
                    },
                    text: {
                        primary: mode === 'light' ? '#1a1a1a' : '#ffffff',
                        secondary: mode === 'light' ? '#666666' : '#b0b0b0',
                    },
                },
                typography: {
                    fontFamily: "'Poppins', sans-serif",
                    h1: { fontWeight: 800 },
                    h2: { fontWeight: 700 },
                    h3: { fontWeight: 600 },
                    button: { fontWeight: 600, textTransform: 'none' },
                },
                shape: {
                    borderRadius: 16,
                },
                components: {
                    MuiButton: {
                        styleOverrides: {
                            root: {
                                borderRadius: 30,
                                padding: '10px 24px',
                            },
                        },
                    },
                },
            }),
        [mode],
    );

    return (
        <ThemeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
};
